module.exports = __webpack_public_path__ + "img/banner-tc4.aec987ce.jpg";